import { MeetingConsumer, MeetingProvider } from '@videosdk.live/react-sdk';
import { memo, useCallback, useContext, useState } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { createMeeting, getToken } from './api';
import JoinScreen from './JoinScreen';
import MeetingGrid from './MeetingGrid';

const MeetingScreen = () => {
  const {
    authState: { user },
  } = useContext(AuthContext);
  const [token, setToken] = useState(null);
  const [meetingId, setMeetingId] = useState(null);

  const getMeetingAndToken = useCallback(async () => {
    const token = await getToken();
    setToken(token);
    setMeetingId(meetingId ? meetingId : await createMeeting({ token }));
  }, [meetingId]);

  const updateMeetingId = useCallback((meetingId) => {
    setMeetingId(meetingId);
  }, []);

  const leaveRoom = useCallback(() => {
    setToken(null);
    setMeetingId(null);
  }, []);

  return token && meetingId ? (
    <MeetingProvider
      config={{
        meetingId,
        micEnabled: true,
        webcamEnabled: true,
        name: user.fullName,
      }}
      token={token}
      style={{
        minHeight: '100vh',
      }}
    >
      <MeetingConsumer>
        {() => <MeetingGrid meetingId={meetingId} leaveRoom={leaveRoom} />}
      </MeetingConsumer>
    </MeetingProvider>
  ) : (
    <JoinScreen
      updateMeetingId={updateMeetingId}
      getMeetingAndToken={getMeetingAndToken}
      style={{
        minHeight: '100vh',
      }}
    />
  );
};

export default memo(MeetingScreen);
